module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronUp-889e3d21c71c0ee873d02268e7173a3d.png";